import React, {useState} from "react";
import {Column, ColumnGrid} from "../ui/spectre/grid";
import translate from "../../../translate";
import Editable from "../ui/editable";
import {Button, ButtonTypes} from "../ui/spectre/buttons";
import {useNavigate} from "../../hooks/useNavigate";
import API from "../../../api/api";
import Sizes from "../ui/spectre/common/sizes";

export default function CreateGroup() {
    const [groupName, setGroupName] = useState(translate('page/group/create/default_name'));
    const navigate = useNavigate();

    async function submit() {
        const newGroupData = await API.post('groups/create', { name: groupName });
        navigate('/group/' + newGroupData.id + '/created');
    }

    return <ColumnGrid size={Sizes.sm}>
        <Column sizes={[6]}>{translate('page/group/create/create_name')}</Column>
        <Column sizes={[6]}><Editable onChange={setGroupName} value={groupName} /></Column>
        <Column sizes={[12]}>
            <div className={'text-center mt-2'}>
                <Button buttonTypes={[ButtonTypes.primary]} className={'btn-with-gap'} onClick={submit}>{translate('dialog_save')}</Button>
                <Button buttonTypes={[ButtonTypes.primary]} className={'btn-with-gap'} onClick={() => navigate(-1)}>{translate('dialog_abort')}</Button>
            </div>
        </Column>
    </ColumnGrid>
}
